import { useQuery } from '@tanstack/react-query';

import { useApi } from '@/hooks/use-api';
import { apiService } from '@/services/api-service';
import { holdsEffectiveFlag } from '@/utils/feature-flags';

export function useFeatureFlags() {
	const { user } = useApi();
	const { data: flags, isLoading } = useQuery({
		queryKey: ['featureFlags', 'me'],
		queryFn: async (): Promise<Record<string, boolean>> => {
			return apiService.fetchApi('/me/feature-flags');
		},
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
	});

	// The Admin role passes every flag but `sql_admin` (#627), exactly as the server's gates do,
	// so no nav row or page guard hides an area the API would serve. `flags` stays the raw rows.
	const hasFlag = (name: string): boolean => holdsEffectiveFlag(user?.role, flags, name);

	return {
		flags: flags || {},
		isLoading,
		hasFlag,
	};
}
